import { LanguageSelect } from '@bak/admin-ui'

import { useLang, useT } from './index.js'

/** Interface language of the CMS (not the language of the content being edited). */
export function LanguageSwitch({ className = '' }: { className?: string }) {
  const { lang, setLang } = useLang()
  const t = useT()
  return <LanguageSelect lang={lang} setLang={setLang} label={t('common.interfaceLanguage')} className={className} />
}
